export type ApplicantContactInfo = {
  email?: string
  mobileNumber?: string
}

const normalizeApplicantEmail = (value = ''): string =>
  value.trim().toLowerCase()

export const normalizeApplicantMobile = (value = ''): string => {
  const digitsOnly = value.replace(/[^0-9]/g, '')
  if (!digitsOnly) return ''

  if (digitsOnly.length === 11 && digitsOnly.startsWith('61')) {
    return `0${digitsOnly.slice(2)}`
  }

  return digitsOnly
}

export const isCurrentUserInApplicants = (
  applicants: ApplicantContactInfo[],
  currentUserEmail?: string,
): boolean => {
  const normalizedCurrentUserEmail = normalizeApplicantEmail(
    currentUserEmail || '',
  )
  if (!normalizedCurrentUserEmail) {
    return false
  }

  return applicants.some(
    (applicant) =>
      normalizeApplicantEmail(applicant.email) === normalizedCurrentUserEmail,
  )
}

export const hasDuplicateApplicantContacts = (
  applicants: ApplicantContactInfo[],
): boolean => {
  const seenApplicantKeys = new Set<string>()

  return applicants.some((applicant) => {
    const emailKey = normalizeApplicantEmail(applicant.email || '')
    const mobileKey = normalizeApplicantMobile(applicant.mobileNumber || '')
    const dedupeKeys: string[] = []

    if (emailKey) dedupeKeys.push(`email:${emailKey}`)
    if (mobileKey) dedupeKeys.push(`mobile:${mobileKey}`)
    if (dedupeKeys.length === 0) {
      return false
    }

    const hasDuplicateKey = dedupeKeys.some((key) => seenApplicantKeys.has(key))
    dedupeKeys.forEach((key) => seenApplicantKeys.add(key))
    return hasDuplicateKey
  })
}
